import { giphyIndigo, giphyLightestGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import Background from './background-video'
import Starters from './starters'

const Container = styled.div`
    padding-top: 20px;
    text-align: left;
    -webkit-font-smoothing: antialiased;
`

const Image = styled.img`
    display: block;
    margin-bottom: 10px;
    width: 100%;
`

const Content = styled.div`
    padding: 0 20px;
`

const Title = styled.h1`
    font-family: 'nexaregular', sans-serif;
    font-size: 30px;
    font-weight: normal;
    margin-bottom: 15px;

    strong {
        font-family: 'nexablack', sans-serif;
    }
`

const Description = styled.p`
    color: ${giphyLightestGrey};
    font-size: 18px;
    line-height: 1.4;
    margin-bottom: 30px;
`

const Disclaimer = styled.div`
    align-items: center;
    background: ${giphyIndigo};
    border-radius: 2px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    font-weight: bold;
    min-height: 50px;
    padding: 0 15px;
    width: 100%;

    i {
        display: inline-block;
        margin-right: 8px;
        margin-top: 5px;
        vertical-align: middle;
    }
`

const Arrow = styled.div`
    font-size: 18px;
    margin-bottom: 60px;
    padding: 30px 0;
    text-align: center;
`

const BackdropMaker = () => {
    return (
        <>
            <Background />
            <Container>
                <Image src="/static/img/zoomies.gif" alt="" />
                <Content>
                    <Title>
                        <strong>GIPHY</strong> Backdrop
                    </Title>
                    <Description>
                        Make any video conference far more fun by creating your own Zoom Virtual Background! Begin by
                        uploading a background or choosing one of our starters.
                    </Description>
                    <Disclaimer>
                        <i className="ss-info" /> Sorry, GIPHY Backdrop is for Desktop only!
                    </Disclaimer>
                    <Arrow>
                        <i className="ss-navigatedown" />
                    </Arrow>
                </Content>
                <Starters />
            </Container>
        </>
    )
}

export default BackdropMaker
